import { render, staticRenderFns } from "./contact-relation-category-table.vue?vue&type=template&id=121c4314&scoped=true&"
import script from "./contact-relation-category-table.ts?vue&type=script&lang=ts&"
export * from "./contact-relation-category-table.ts?vue&type=script&lang=ts&"
import style0 from "./contact-relation-category-table.scss?vue&type=style&index=0&id=121c4314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121c4314",
  null
  
)

export default component.exports